export default __webpack_public_path__ + "static/pleading-face-1ceb01cecb53df68e13cc70b14b07801.png";